import * as yup from 'yup';

const descargarReporteSchema = yup.object().shape({
  fechaDisponibilidadInicio: yup
    .date()
    .nullable()
    .typeError('La fecha ingresada no es válida')
    .when(['tipo', 'tipoExportacion'], {
      is: (tipo, tipoExportacion) =>
        (tipo === 'completo' || tipo === 'personalizado') &&
        (tipoExportacion === 'Recurso adquirido' ||
          tipoExportacion === 'Residuo declarado'),
      then: schema => schema.required('La fecha de inicio es obligatoria')
    }),
  fechaDisponibilidadTermino: yup
    .date()
    .nullable()
    .typeError('La fecha ingresada no es válida')
    .when(['tipo', 'tipoExportacion'], {
      is: (tipo, tipoExportacion) =>
        (tipo === 'completo' || tipo === 'personalizado') &&
        (tipoExportacion === 'Recurso adquirido' ||
          tipoExportacion === 'Residuo declarado'),
      then: schema => schema.required('La fecha de término es obligatoria')
    }),
  anyo: yup
    .date()
    .nullable()
    .typeError('La fecha ingresada no es válida')
    .when(['tipo', 'periodo'], {
      is: (tipo, periodo) => tipo === 'sinader' && periodo === 'anual',
      then: schema => schema.required('El año es obligatorio')
    }),
  mesAnyo: yup
    .date()
    .nullable()
    .typeError('La fecha ingresada no es válida')
    .when(['tipo', 'periodo'], {
      is: (tipo, periodo) => tipo === 'sinader' && periodo === 'mensual',
      then: schema => schema.required('El mes y año son obligatorios')
    })
});

export { descargarReporteSchema };
